import React from "react";
import "./diagnosticReportTextDetails.css";
import { formatDate } from "../../service/constants";
const DiagnosticReportTextDetails = ({ diagnosticDetailsData }) => {
  return (
    <div className="info-container">
      <div>
        <span className="label">Report Name - </span>{" "}
        {diagnosticDetailsData.resource.code.text}
      </div>
      {diagnosticDetailsData.resource.performer && (
        <div>
          <span className="label">Hospital - </span>{" "}
          {diagnosticDetailsData.resource.performer[0].display}
        </div>
      )}
      <div>
        <span className="label">Date - </span>{" "}
        {formatDate(diagnosticDetailsData.resource.effectiveDateTime)}
      </div>
    </div>
  );
};

export default DiagnosticReportTextDetails;
